import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { SAMPLE_MRZ_LOWER, SAMPLE_MRZ_UPPER } from './sample-data';
import { cmd, WebSocketServiceStubBase, WSStubResponse } from './web-socket-stub-base';

export class HWCameraWebSocketStub extends WebSocketServiceStubBase {
  override generateListOfCommands() {
    return [
      cmd('list-cameras').withCallback(this.responseListCameras),
      cmd('list-formats').withCallback(this.responseListFormats),
      cmd('start-streaming').withCallback(this.responseStartStreaming),
      cmd('stop-streaming').withDefaultResponse(),
      cmd('light').withDefaultResponse(),
      cmd('capture').withCallback(this.responseCapture),
      cmd('set-light').withDefaultResponse(),
      cmd('get-light').withCallback(this.responseGetLight),
      cmd('load-light-preset').withCallback(this.responseLoadLightPreset),
      cmd('save-light-preset').withDefaultResponse(),
      cmd('describe-light').withCallback(this.responseDescribeLight),
      cmd('select-camera').withDefaultResponse(),
      cmd('get-selected-camera').withCallback(this.responseGetSelectedCamera),
      cmd('terminate-voip-calls-on-close').withDefaultResponse(),
    ];
  }

  // Команды сервиса камеры

  private responseListCameras(data: any) {
    this.sendResponse(
      new WSStubResponse('list-cameras', {
        cameras: [
          { id: 0, type: 'back' },
          { id: 1, type: 'front' },
        ],
      }),
    );
  }

  private responseListFormats(data: any) {
    this.sendResponse(
      new WSStubResponse('list-formats', {
        formats: [{ 'fps': 30, 'frame-format': 'JPEG', 'height': 150, 'width': 200 }],
      }),
    );
  }

  private responseStartStreaming(data: any) {
    if (data.process === 'none') {
      this.sendResponse(new WSStubResponse('start-streaming'));
    } else if (data.process === 'MRZ') {
      this.sendResponse(new WSStubResponse('start-streaming'));
      of(undefined)
        .pipe(delay(500))
        .subscribe(() =>
          this.sendResponse(
            new WSStubResponse('MRZ', {
              upper: SAMPLE_MRZ_UPPER,
              lower: SAMPLE_MRZ_LOWER,
            }),
          ),
        );
    } else if (data.process === 'signature') {
      this.sendResponse(new WSStubResponse('start-streaming'));
    }
  }

  private responseCapture(data: any) {
    this.sendResponse(new WSStubResponse('capture'));
    of(undefined)
      .pipe(delay(1000))
      .subscribe(() => this.responseEndOfStream(data));
  }

  private responseGetLight(data: any) {
    this.sendResponse(
      new WSStubResponse('get-light', {
        channel: 0,
        value: 0,
      }),
    );
  }

  private responseLoadLightPreset(data: any) {
    this.sendResponse(
      new WSStubResponse('load-light-preset', {
        name: data.name,
        channels: [0],
      }),
    );
  }

  private responseDescribeLight(data: any) {
    this.sendResponse(
      new WSStubResponse('describe-light', {
        channels: [],
      }),
    );
  }

  private responseGetSelectedCamera(data: any) {
    this.sendResponse(
      new WSStubResponse('get-selected-camera', {
        'camera-id': 0,
      }),
    );
  }

  private responseEndOfStream(data: any) {
    this.sendResponse(new WSStubResponse('end-of-stream'));
  }
}
